(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonial-slider-2"] && !window.DesignMode) return;
  try {
    
            $('.image-slider2').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 400,
    respondTo: "min",
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,


        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial-slider"] && !window.DesignMode) return;
  try {
    
            $('.image-slider1').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 400,
    respondTo: "min",
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,


        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ]
  });

    // equal hight card script
 function setEqualHeight() {
  const cards = document.querySelectorAll('.user_reviews');

  if (!cards.length) return;
  cards.forEach(card => (card.style.height = 'auto'));
  const maxHeight = Math.max(...Array.from(cards).map(card => card.offsetHeight));
  cards.forEach(card => (card.style.height = `${maxHeight}px`));
}
function initializeEqualHeight() {
  setEqualHeight();
  window.addEventListener('resize', setEqualHeight);
  window.addEventListener('orientationchange', setEqualHeight);
}
document.addEventListener('DOMContentLoaded', initializeEqualHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-new"] && !window.DesignMode) return;
  try {
    
   // influencer videos
   const productVideos = document.querySelectorAll(".product_video")
  
  productVideos[0].addEventListener("click", (e)=>{

       if(e.target.muted){
         e.target.muted=false
       }
       else{
         e.target.muted=true
       }

  })

   //
   const observer = new IntersectionObserver(
       (entries) => {
         entries.forEach((entry) => {
           const video = entry.target;
           if (entry.isIntersecting) {
             video.play();
           } else {
             video.pause();
             video.muted=true
           }
         });
       },
       { threshold: 0.5 }
     );

     productVideos.forEach((video) => {
       observer.observe(video);
     });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutom-video-slider"] && !window.DesignMode) return;
  try {
    
       $('.video-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 500,
    respondTo: "min",
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  // influencer videos
  const videos = document.querySelectorAll(".influencer_video")
  videos.forEach((influVideo, index)=>{
    influVideo.addEventListener("click", (e)=>{

      videos.forEach((restiInfluVideo, restIndex)=>{
        if(index!=restIndex){
          restiInfluVideo.muted=true
        }
      })
      
      if(e.target.muted){
        e.target.muted=false
      }
      else{
        e.target.muted=true
      }
      
    })
  })

  // 
  const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
            video.muted=true
          }
        });
      },
      { threshold: 0.5 }
    );

    videos.forEach((video) => {
      observer.observe(video);
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
